<template>
	<div
		class="banner-upload"
		v-loading="loading"
		element-loading-text="图片上传中"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-tooltip
			effect="dark"
			content="上传成功!"
			placement="top"
			v-model="tooltipShow"
			:manual="true">
			<p></p>
		</el-tooltip>
		<p class="error-msg" v-if="uploadError">上传失败,请重新上传!</p>
		<div v-if="previewSrc === ''" class="banner-add el-icon-plus" @click="uploadHandler"></div>
		<div v-else class="img-preview-block" @mouseover="imgMouseOver" @mouseout="imgMouseOut">
			<w-image v-if='shopOrProduct === 1' :src="previewSrc" alt="" class="img-preview" @click="uploadHandler"></w-image>
			<w-image v-if='shopOrProduct === 0' :src="previewSrc" alt="" class="img-preview" @click="uploadHandler"></w-image>
			<div class="img-btn" v-show="activeFlag">
				<el-button type="primary" class="btn" @click="uploadHandler"><i class="el-icon-upload"></i></el-button>
				<el-button type="danger" class="btn" @click="deleteClick"><i class="el-icon-delete"></i></el-button>
			</div>
		</div>
		<input type="file" ref="file" id="file" accept="image/png,image/jpeg,image/jpg" v-show="false" @change="getFile">
		<!-- <p style="color:#606266b5">80*80,1M以内，png/jpg/jpeg格式</p> -->
	</div>
</template>

<script>
export default {
	name: 'bannerUpload',
	props: {
		shopOrProduct: Number,
		imgSrc: {
			type: String,
			default: ''
		},
		productId: String,
		shopId: String

	},
	data () {
		return {
			uploadError: false,
			previewSrc: '',
			fileName: '',
			file: '',
			type: '',
			uploadType: new RegExp(/image\/png|image\/jpg|image\/jpeg/),
			uploadTypeText: 'png,jpg,jpeg',
			uploadSize: 1,
			activeFlag: false,
			loading: false,
			tooltipShow: false,
			tooltipTimer: null
		}
	},
	watch: {
		imgSrc (val) {
			this.previewSrc = val
			this.$refs.file.value = ''
		}
	},
	created () {
		this.previewSrc = this.imgSrc
	},
	methods: {
		imgMouseOver () {
			this.activeFlag = true
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		uploadHandler () {
			this.$refs.file.click()
		},
		getFile (e) {
			let files = e.target.files[0]
			let type = files.type
			let size = files.size / 1024 / 1024
			this.fileName = files.name
			let a = []
			a = this.fileName.trim().split('.')
			this.file = files
			this.file = files
			this.type = a[a.length - 1]
			if (!this.uploadType.test(type)) {
				this.$message.error(`上传图片只支持${this.uploadTypeText}格式!`)
				return false
			}
			if (size > this.uploadSize) {
				this.$message.error(`上传图片大小不能超过${this.uploadSize}M!`)
				return false
			}
			if (!e || !window.FileReader) {
				return false
			}
			let reader = new FileReader()
			reader.readAsDataURL(files)
			reader.onloadend = () => {
				let image = new Image()
				image.src = reader.result
				image.onload = () => {
					this.previewSrc = reader.result
					this.upLoadImg()
				}
			}
		},
		upLoadImg () {
			var formData = new FormData()
			if (this.shopOrProduct === 1) {
				if (this.productId !== '') {
					formData.append('id', this.productId)
				}
			} else {
				if (this.shopId !== '') {
					formData.append('id', this.shopId)
				}
			}
			formData.append('extension', this.type)
			formData.append('imgType', this.shopOrProduct)
			formData.append('file', this.file)
			this.$store.dispatch('requestFilePost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/defaultimg/upload`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$emit('relaod', true)
					this.$message.success('上传成功')
				} else {
					this.uploadError = true
					this.previewSrc = ''
					this.$refs.file.value = ''
				}
			})
		},
		deleteClick () {
			let params = {
				id: '',
				imgType: null
			}
			if (this.shopOrProduct === 1) {
				params.id = this.productId
				params.imgType = 1
			} else {
				params.id = this.shopId
				params.imgType = 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/defaultimg/del`,
				data: params
			}).then(res => {
				if (res.result) {
					this.previewSrc = ''
					this.$refs.file.value = ''
					this.$message.success('删除成功')
					if (this.shopOrProduct === 1) {
						this.$emit('delProductId')
					} else {
						this.$emit('delShopId')
					}
					this.$emit('relaod', true)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		showTooltip () {
			this.tooltipShow = true
			if (this.tooltipTimer) {
				clearTimeout(this.tooltipTimer)
			}
			this.tooltipTimer = setTimeout(() => {
				this.tooltipShow = false
			}, 1500)
		}
	}
}
</script>
<style lang="stylus" scoped>
.banner-upload {
	margin-left :30px;
	width: 130px;
	height: 130px;
	overflow: hidden;
	box-sizing:border-box
	position:relative
	.error-msg {
		color:red;
		position:absolute;
		top: 106px;
        left: 7px
	}
	.banner-add,.img-preview-block {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box;
		width: 100px;
		height: 100px;
		line-height: 100px;
		background-color :#fff;
		display: inline-block
	}
	.banner-add {
		border: 1px dashed #d9d9d9;
		cursor: pointer;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		&:hover {
			border-color: var(--fx-primary-color);
		}
	}
	.img-preview-block {
		position:relative;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
        .btn{
            width :30px;
            height :30px;
            padding 0
        }
		.img-preview {
			width:100%;
			height:100%;
		}
		.img-btn {
			position: absolute;
			top:0px;
			right:0px;
			height:100%;
			width:100%;
			background-color:rgba(0,0,0,0.1)
		}
	}
}
</style>
